type LanguageOptionProps = {
  active: boolean;
  id: string;
  language: {
    name: string;
    src: string;
  };
  onChange: () => void;
};

export function LanguageOption({ active, id, language, onChange }: LanguageOptionProps) {
  return (
    <label
      className={`profile-slider-btn language-option ${active ? 'active' : ''}`}
      htmlFor={`language-radio-${id}`}
    >
      <input
        type="radio"
        id={`language-radio-${id}`}
        name="language-selection"
        value={id}
        checked={active}
        onChange={onChange}
        className="visuallyHidden"
        aria-describedby={`language-description-${id}`}
      />
      <div className="menu-item">
        <img src={language.src} alt="" className="slider-icon" />
        <div className="slider-text" id={`language-description-${id}`}>
          {language.name}
        </div>
      </div>
    </label>
  );
}
